/**
 * Velger hvilken foto-attribusjon som kan vises for auto-hentede bilder.
 * Historikk: malen «Foto: {{credit}} via {{source}}» ble rendret rått selv når
 * begge feltene var tomme → brukere så en meningsløs «Foto: via»-stripe.
 */
export interface PhotoCreditInput {
  credit?: string;
  source?: string;
}

export type PhotoCreditVariant =
  | { kind: 'full'; credit: string; source: string }
  | { kind: 'single'; value: string }
  | null;

export const photoCreditVariant = (i: PhotoCreditInput): PhotoCreditVariant => {
  const credit = i.credit?.trim();
  const source = i.source?.trim();
  if (credit && source) return { kind: 'full', credit, source };
  const single = credit || source;
  return single ? { kind: 'single', value: single } : null;
};
